import Vue from 'vue';
import Vuex from 'vuex';
import { TYPES_PLATFORM } from '@/js/helpers/globalConst';

Vue.use(Vuex);

const debug = process.env.NODE_ENV === 'production';

export default new Vuex.Store({
  strict: debug,

  state: {
    loadingFlags: [],
    notifications: [],
    platform: 'mobile',
  },

  mutations: {
    setLoadingFlags(state, flagObj) {
      Vue.set(state.loadingFlags, flagObj.name, state.loadingFlags[flagObj.name] || []);

      if (flagObj.bool) {
        state.loadingFlags[flagObj.name].push(true);
      } else {
        state.loadingFlags[flagObj.name].pop();
      }
    },

    setLoading(state, name) {
      Vue.set(state.loadingFlags, name, state.loadingFlags[name] || []);
      state.loadingFlags[name].push(true);
    },

    clearNotification(state) {
      state.notifications = [];
    },

    setPlatform(state, platform = TYPES_PLATFORM.mobile) {
      state.platform = platform;
    },

    unsetLoading(state, name) {
      Vue.set(state.loadingFlags, name, state.loadingFlags[name] || []);
      state.loadingFlags[name].pop();
    },

    addErrorNotifications(state, errors) {
      errors.forEach((data) => {
        state.notifications.push({
          type: 'error',
          title: 'Ошибка',
          message: data.title,
        });
      });
    },
  },

  getters: {
    getLoading({ loadingFlags }) {
      return stackName => !!(loadingFlags[stackName] || []).length;
    },

    isMobile(state) {
      return state.platform === TYPES_PLATFORM.mobile;
    },

    hasLoading({ loadingFlags }) {
      return stackName => !!(loadingFlags[stackName] || []).length;
    },
  },
});
